module.exports = __webpack_public_path__ + "media/images/recipes/ribkarbonade-ba4072a81333eb37b3da847b2ea07e88.pdf";